import React, { useEffect, useState } from "react";
import { AppBar, Box, CssBaseline, Drawer, Toolbar, Typography } from '@mui/material';
import LogoIcon from '../../assets/images/Logo.svg';
import homeSolid from '../../assets/images/icon/homein.svg';
import NetworkIconSolid from '../../assets/images/NetworkIconSolid.svg';
import RegCusIcon from '../../assets/images/icon/reg.svg';
// import RegCusIconSolid from '../../assets/images/icon/regSolid.svg';
import OrderIcon from '../../assets/images/icon/Order.svg';
// import OrderSolid from '../../assets/images/icon/OrderSolid.svg';
import InstallationIcon from '../../assets/images/icon/Installation.svg';
import InstallationIconSolid from '../../assets/images/icon/InstallationSolid.svg';
import notiIcon from '../../assets/images/icon/noti.svg';
import infoIcon from '../../assets/images/icon/info.svg';
import chatIcon from '../../assets/images/icon/chat.svg';
import LicensesIcon from '../../assets/images/icon/lc.svg';
import LicensesSolid from '../../assets/images/icon/licensesSolid.svg';
import { Link, useLocation } from "react-router-dom";
import { UserProfile } from "./UserProfile";
import { getUserPriority } from "../../services/authService";
import { PROFILE_TYPE } from "../../helper/globalConstant";


const LeftSidebar: React.FC = () => {

    const location = useLocation();
    const [openUserProfile, setOpenUserProfile] = useState(false);
    const [priorityId, setPriorityId] = useState();
    const [userPriority, setUserPriority] = useState();

    const handleUserProfileToggle = () => {
        setOpenUserProfile(!openUserProfile);
    };


    useEffect(() =>{
        fetchUserPriority();
    }, [])



    const fetchUserPriority = async () => {
        const priority = await getUserPriority();
        setUserPriority(priority);
    }


    const [profileId, setProfileId] = useState<number | null>(null);
    const [loginUserName, setLoginUserName] = useState("A");

    useEffect(() => {
        // Retrieve user data from localStorage
        const sess_user_data = localStorage.getItem("sess_user");

        if (sess_user_data != null) {
            try {
                const sess_user = JSON.parse(sess_user_data); // Parse session data

                // Safely extract profileId
                const extractedProfileId = sess_user?.userProfile?.priority;
                const extractedName = sess_user?.user?.name;
                if (extractedProfileId) {
                    setProfileId(extractedProfileId);
                } else {
                    console.error("Profile ID not found in userProfile");
                }

                if(extractedName){
                    setLoginUserName(extractedName.charAt(0));
                }

            } catch (error) {
                console.error("Error parsing session user data:", error);
            }
        }
    }, []);

    return (
        <>
            <Drawer className="sidebar" variant="permanent"
                sx={{
                    width: 240,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: 240, boxSizing: 'border-box' },
                }}
            >
                {/* <Toolbar /> */}
                <Box sx={{ overflow: 'none' }}>
                    <div className="sidebarContent margin20">
                        <span className="iCon">
                            <img src={LogoIcon} alt="" width={50} height={50} />
                        </span>
                    </div>
                    {/* <div className={`sidebarContent ${location?.pathname?.split("/")[1] === 'customer' ? 'activeIn' : ''}`}> */}
                    <div className={`sidebarContent 
                        ${location?.pathname.startsWith('/customer/overview') 
                        || location?.pathname.startsWith('/customer/details') 
                        || location?.pathname.startsWith('/customer/view') ? 'activeIn' : ''} ? 'activeIn' : ''}`}>
                        <Link to="/customer/overview">
                            <span className="iCon">
                                <img src={"/icons/menu/home.png"} alt="" width={24} height={24} className="OutHover" />
                                <img src={"/icons/menu/home_blue.svg"} alt="" width={24} height={24} className="InHover" />
                            </span>
                            <Typography variant="h5" sx={{ p: 2 }}>
                                Home
                            </Typography>
                        </Link>
                    </div>
                    {userPriority !== PROFILE_TYPE.SUPER_ADMIN && <div className={`sidebarContent ${location?.pathname.startsWith('/customer/new') ? 'activeIn' : ''}`}>
                        <Link to="/customer/new">
                            <span className="iCon">
                                <img src={"/icons/menu/customer.png"} alt="" width={24} height={24} className="OutHover" />
                                <img src={"/icons/menu/customer_blue.png"} alt="" width={24} height={24} className="InHover" />
                            </span>
                            <Typography variant="h5" sx={{ p: 2 }}>
                                Register Customer
                            </Typography>
                        </Link>
                    </div>
                    }
                    <div className={`sidebarContent ${location?.pathname.startsWith('/orders') ? 'activeIn' : ''}`}>
                        <Link to="/orders">
                            <span className="iCon">
                                <img src={"/icons/menu/order.svg"} alt="" width={24} height={24} className="OutHover" />
                                <img src={"/icons/menu/order_blue.png"} alt="" width={24} height={24} className="InHover" />
                            </span>
                            <Typography variant="h5" sx={{ p: 2 }}>
                                Orders
                            </Typography>
                        </Link>
                    </div>
                    <div className={`sidebarContent 
                        ${location?.pathname.startsWith('/licenses') ? 'activeIn' : ''}`
                    }>
                        <Link to="/licenses">
                            <span className="iCon">
                                <img src={"/icons/menu/license.svg"} alt="" width={24} height={24} className="OutHover" />
                                <img src={"/icons/menu/license_blue.png"} alt="" width={24} height={24} className="InHover" />
                            </span>
                            <Typography variant="h5" sx={{ p: 2 }}>
                                Licenses
                            </Typography>
                        </Link>
                    </div>

                    {/* {profileId === PROFILE_TYPE.SUPER_ADMIN && (
                        <div className={`sidebarContent ${location?.pathname.startsWith('/partner') ? 'activeIn' : ''}`}>
                            <Link to="/partner">
                                <span className="iCon">
                                    <img src={"/icons/menu/customer.png"} alt="" width={24} height={24} className="OutHover" />
                                    <img src={"/icons/menu/customer_blue.png"} alt="" width={24} height={24} className="InHover" />
                                </span>
                                <Typography variant="h5" sx={{ p: 2 }}>
                                    Partner
                                </Typography>
                            </Link>

                        </div>
                    )} */}
                    {(profileId == PROFILE_TYPE.INTEGRATOR || profileId === PROFILE_TYPE.SUPER_ADMIN) && 
                    <div className={`sidebarContent ${location?.pathname.startsWith('/admin') ? 'activeIn' : ''}`}>
                        <Link to="/admin">
                            <span className="iCon">
                                <img src={"/icons/menu/admin.svg"} alt="" width={24} height={24} className="OutHover" />
                                <img src={"/icons/menu/admin-active.svg"} alt="" width={24} height={24} className="InHover" />
                            </span>
                            <Typography variant="h5" sx={{ p: 2 }}>
                                Admin
                            </Typography>
                        </Link>
                    </div>
                    }



                    {/* <div className={`sidebarContent ${location?.pathname === '/Installation' ? 'activeIn' : ''}`}>
                        <Link to="/Installation">
                            <span className="iCon">
                                <img src={"/icons/menu/customer.png"} alt="" width={24} height={24} className="OutHover" />
                                <img src={"/icons/menu/customer_blue.png"} alt="" width={24} height={24} className="InHover" />
                            </span>
                            <Typography variant="h5" sx={{ p: 2 }}>
                                Installation
                            </Typography>
                        </Link>
                    </div> */}
                </Box>
                <Box sx={{ overflow: 'none' }} className="ProfileArea">
                    {/* <div className={`sidebarContent ${location?.pathname.startsWith('/status') ? 'activeIn' : ''}`}>
                        <Link to="/status">
                            <span className="iCon">
                                <img src={chatIcon} alt="" width={24} height={24} className="OutHover" />
                            </span>
                        </Link>
                    </div>
                    <div className={`sidebarContent ${location?.pathname.startsWith('/status') ? 'activeIn' : ''}`}>
                        <Link to="/status">
                            <span className="iCon">
                                <img src={infoIcon} alt="" width={24} height={24} className="OutHover" />
                            </span>
                        </Link>
                    </div>
                    <div className={`sidebarContent ${location?.pathname.startsWith('/status') ? 'activeIn' : ''}`}>
                        <span className="iCon">
                            <img src={notiIcon} alt="" width={20} height={20} className="OutHover" />
                        </span>
                    </div> */}
                    <div className="sidebarContent" onClick={handleUserProfileToggle}>
                        <div className="hUser">{loginUserName}</div>
                    </div>
                </Box>
            </Drawer>


            {openUserProfile && <UserProfile handleUserProfileToggle={handleUserProfileToggle} />}
        </>
    )
}


export default LeftSidebar;
